export const es_custom = {
    'capital_invested' : 'Capitale investito',
    'label_label': 'Etichetta',
    'label_price': 'Importo',
    'label_price_pay': 'Prezzo d\'acquisto',
    'label_income': 'Estado de Cuenta',
    'label_consumptive': 'Consuntivo',
    'await_building': 'Prima di compilare il conto economico, assicurati di aver inserito i dati della <strong>"scheda operazione"</strong>.',
    'await_todo': 'Prima di utilizzare la to do list, assicurati di aver inserito i dati della <strong>"scheda operazione"</strong>.',
    'label_add_cost' : 'Aggiungi costo',
    'label_list_cost' : 'Costi',
    'label_revenues': 'Ricavi',
    'label_add_resource_alert' : 'Prima di caricare una risorsa, inserisci un immobile',
    'label_add_resource': 'Nuevo Recurso',
    'label_configuring': 'Configura questo CE',
    'label_modal_configure': 'CONFIGURATORE CE',
    'label_percentage_estate_worst_scenario': 'Scenario Peggiore',
    'label_percentage_estate_middle_scenario': 'Scenario Medio',
    'label_percentage_estate_better_scenario': 'Scenario Migliore',
    'label_percentage_estate_consumptive': 'Consuntivo',
    'label_template_list': 'Lista template',

    'popover_buildingData_title': 'La tua operazione',
    'popover_buildingData_content': '<p>Administra la ficha de tu operación, modifica los datos, personaliza tu declaración de la renta, ingresa al equipo de trabajo que opera sobre la operación. Adjunte fotos y documentos y complete la "Lista de pendientes" y organice las acciones a realizar.</p>',

    'popover_income_title': 'Estado de Cuenta',
    'popover_income_content': '<p>!Introduce los valores y calcula automáticamente el ROI y el ROE. Evalúe el escenario y estime los costos e ingresos de la transacción completada.' +
        '\n' +
        'Aggiungi o sottrai le righe e le descrizioni dei valori in base alle tue necessità e configura il tuo conto.</p>',

    'popover_resource_title': 'Recursos',
    'popover_resource_content': '<p>Adjunte el contenido fotográfico y toda la documentación útil para realizar su operación.\n</p>',


    'popover_incomefreeAgency_title': 'Agenzia Acquisto',
    'popover_incomefreeAgency_content': '<p>COSTO IMMOBILE(Acquisto) * Percentuale <hr> (Si può impostare la percentuale nel configuratore del conto economico).</p>',

    'popover_incomefreeAgencySell_title': 'Agenzia Vendita',
    'popover_incomefreeAgencySell_content': '<p>COSTO IMMOBILE(Vendita) * Percentuale <hr> (Si può impostare la percentuale nel configuratore del conto economico).</p>',

    'popover_incomefreeRegisterTax_title': 'Tassa Registro',
    'popover_incomefreeRegisterTax_content': '<p>1a Casa: (Rendita Catastale * 115.5 * 2) / 100 <br>' +
        '2a Casa: (Rendita Catastale * 126 * 9) / 100<br><br>' +
        '(La Rendita Catastale si può impostare nel configuratore del conto economico).</p>',


    'popover_incomefreeTotPurchase_title': 'Totale Costi Acquisto',
    'popover_incomefreeTotPurchase_content': '<p>E\' rappresentato dal totale dei costi.</p>',

    'popover_incomefreeSubstitutiveTax_title': 'Imposta sostitutiva',
    'popover_incomefreeSubstitutiveTax_content': '<p>VALORE FINANZIATO * Percentuale<hr> (Si può impostare la percentuale nel configuratore del conto economico).</p>',

    'popover_incomefreeTotalFinancingCost_title': 'Totale Costi Finanziamento',
    'popover_incomefreeTotalFinancingCost_content': '<p>E\' il totale del blocco "finanziamento" (escluso "Valore finanziato").</p>',

    'popover_incomefreeTotalCost_title': 'Totale Costi',
    'popover_incomefreeTotalCost_content': '<p>E\' la somma di "Totale Costi finanziamento" e del "Totale Costi di Acquisto".</p>',

    'popover_incomefreeTotalCostMQ_title': 'Totale Costi al MQ',
    'popover_incomefreeTotalCostMQ_content': '<p>"Totale Costi"  /  "Mq" dell\'immobile.</p>',

    'popover_incomefreeTotalCostMQTax_title': 'Totale Costi al MQ per tasse',
    'popover_incomefreeTotalCostMQTax_content': '<p>"Totale Costi di acquisto"  /  "Mq" dell\'immobile.</p>',

    'popover_incomefreeGrossProfit_title': 'Utile Lordo',
    'popover_incomefreeGrossProfit_content': '<p>"Totale ricavi"  -  "Totale Costi".</p>',

    'popover_incomefreeTotalTax_title': 'Totale Tasse',
    'popover_incomefreeTotalTax_content': '<p>"Utile Lordo"  *  "Percentuale 2a casa" <hr>(Si può impostare la percentuale nel configuratore del conto economico).</p>',

    'popover_incomefreeNetIncome_title': 'Utile Netto',
    'popover_incomefreeNetIncome_content': '<p>"Utile Lordo"  -  "Totale tasse" </p>',

    'popover_incomefreeROI_title': 'ROI',
    'popover_incomefreeROI_content': '<p>"Utile Lordo" / "Totale Costi" </p>',

    'popover_incomefreeROE_title': 'ROE',
    'popover_incomefreeROE_content': '<p>"Utile Netto" / "Capitale investito" </p>',
    
    'label_costi': 'COSTOS',
    'label_acquisto': 'Adquisición',
    'label_atto_acquisto': 'Escritura de compra',
    'label_agenzia_acquisto': 'Agencia por adquisición',
    'label_agenzia_vendita': 'Agencia por Venta',
    'label_tassa_registro': 'Impuestos',
    'label_architetto': 'Arquitecto',
    'label_condono': 'Amnistìa fiscal',
    'label_spese_condominiali': 'Gastos condominiales',
    'label_fatture_luce': 'Facturas de servicios luz/gas',
    'label_imprevisti': 'Imprevistos',
    'label_costo_ristrutturazione': 'Costos de reformas',
    'label_costo_totale_acquisto': 'Costos totales de adquisición',
    'label_finanziamento': 'FINANCIAMIENTO',
    'label_valore_finanziamento': 'Valor de financiamiento',
    'label_notaio' : 'Notario para hipoteca',
    'label_costi_gestione': 'Costos de gestiòn',
    'label_perito': 'Tasador',
    'label_spesa_istruttoria': 'Gastos',
    'label_imposta_sostitutiva': 'Impuestos sostitutivos',
    'label_assicurazione': 'Seguro',
    'label_interessi_mesi': 'Intereses mensuales',
    'label_totale_costi_finanziamento': 'Costos totales de financiamiento',
    'label_totale_costi': 'Costos totales',
    'label_totale_costi_mq': 'Costos totales Metro cuadrado',
    'label_totale_costi_mq_tasse': 'Costos totales m2 por impuestos',
    'label_ricavi': 'INGRESOS (street price / m2',
    'label_totale_ricavi': 'Ingresos totales',
    'label_ricavi_mq': 'INGRESOS AL METRO CUADRADO',
    'label_utile_lordo': 'Beneficio bruto',
    'label_tasse': 'IMPUESTOS',
    'label_totale_tasse': 'Impuestos totales',
    'label_utile': 'BENEFICIOS',
    'label_utile_netto': 'Beneficios netos',
    'label_capitale_proprio_investito': 'Capital personal invertido',
    'bottone_salva_scheda_operazione': 'GUARDAR PESTAÑA OPERACIÓN',
};
